// Friendly display names for the raw action / category keys stored by
// trackInteraction (utils/trackInteraction.js -> POST /api/track-event ->
// interactionEvents). Shared by every admin surface that renders those rows —
// Interaction Analytics and the User Activity popup's Clicks tab — so a new
// tracked action gets its label in one place instead of two.

export const ACTION_LABELS = {
  "view-detail": "Viewed Listing",
  "contact-owner": "Contact Owner",
  "send-message": "Send Message",
  "report-spam": "Report Spam",
  "edit-post": "Edit Post",
  "disable-ad": "Disable Ad",
  "service-menu": "Service Menu",
  "directory-category": "More Menu — Category",
  "directory-listing": "Viewed Directory Listing",
  "deals": "Deals (menu)",
  "deal-view": "Viewed Deal",
  "message": "Message",
  "contact": "Contact",
  "post-free-ad": "Post Free Ad",
  "profile": "Profile",
  "country-select": "Country Select",
  "ai-search": "AI Search",
  "hero-search": "Search",
  "advanced-search": "Advanced Search",
  "advanced-apply": "Advanced Applied",
  "page-change": "Pagination",
  "profile-menu": "Profile Menu",
  "logout": "Logout",
  "login-open": "Login Popup Opened",
  "login-submit": "Login Clicked",
  "login-success": "Login Success",
};

export const CATEGORY_LABELS = {
  "view-listing": "View Listing",
  "navbar": "Navbar",
  "search": "Search",
  "page-view": "Page View",
  "auth": "Login",
  "pagination": "Pagination",
};

export function actionLabel(a) {
  if (ACTION_LABELS[a]) return ACTION_LABELS[a];
  // Page-view actions are raw route names (e.g. "admin-console", "view-post").
  // Title-case kebab/snake names so they read as normal words.
  if (typeof a === "string" && a) {
    return a
      .split(/[-_]/)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  }
  return a;
}

export function categoryLabel(c) {
  return CATEGORY_LABELS[c] || c;
}

// One CSS class per category so each event type is instantly recognisable.
export function categoryBadgeClass(c) {
  return {
    "page-view": "admin-cat--pageview",
    "navbar": "admin-cat--navbar",
    "auth": "admin-cat--auth",
    "search": "admin-cat--search",
    "pagination": "admin-cat--search",
    "view-listing": "admin-cat--listing",
  }[c] || "admin-cat--other";
}

// The one-line "what happened" for a click row: pagination reads as a move
// between two pages, a search as the term typed (plus the Where box).
export function clickDetail(e) {
  const m = e.meta || {};
  if (e.action === "page-change") return `Page ${m.from ?? "?"} → ${m.to ?? "?"}`;
  if (e.action === "advanced-search") return "Panel opened";
  const term = e.targetName || e.label || "";
  if (e.action === "advanced-apply") return term || "All listings";
  if (term && m.where) return `${term} in ${m.where}`;
  return term || m.where || "—";
}
